import { Controller } from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import type { Control, FieldValues, Path } from "react-hook-form";
import type { DateView } from "@mui/x-date-pickers/models";

function disableWeekends(date: Date): boolean {
    return date.getDay() === 0 || date.getDay() === 6;
}

export interface InputDatePickerControllerProps<T extends FieldValues = FieldValues> {
    control: Control<T>;
    name: Path<T>;
    label: string;
    defaultValue?: unknown;
    views?: DateView[];
    openTo?: DateView;
    minDate?: Date;
    readOnlyInput?: boolean;
    disabledWeekEnds?: boolean;
}

const InputDatePickerController = <T extends FieldValues = FieldValues>({ control, name, label, defaultValue, views, openTo, minDate, readOnlyInput = false, disabledWeekEnds = false }: InputDatePickerControllerProps<T>) => {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue as never}
            render={({ field }) => (
                <FormControl fullWidth>
                    <DatePicker
                        shouldDisableDate={disabledWeekEnds ? disableWeekends : undefined}
                        label={label}
                        views={views}
                        minDate={minDate === undefined ? new Date("1960-01-01") : minDate}
                        openTo={openTo}
                        {...field}
                        format="yyyy-MM-dd"
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                variant: "outlined",
                                margin: "normal",
                                slotProps: { htmlInput: { readOnly: readOnlyInput } },
                            },
                        }}
                    />
                </FormControl>
            )}
        />
    )
}

export default InputDatePickerController;
